// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent {
  display: grid;
  grid-template-columns: 1fr 4fr;
  
}

.div2 {
  grid-column-start: 1;
  grid-row-start: 2;
}

.div3 {
  grid-column-start: 1;
  grid-row-start: 3;
}

.div4 {
  grid-column-start: 1;
  grid-row-start: 4;
}

.div5 {
  grid-column: span 4;
  grid-row: span 4;
  grid-column-start: 2;
  grid-row-start: 1;
}

.right-column {
  grid-column: 2;
  grid-row: 1;
  padding: 20px;
  max-width: 950px;
}

.subheader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 20px 0;
}

.subheader-item {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #00000038;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 16px;
  min-width: 150px;
}

.circle-icon {
  color: green;
  margin-right: 10px;
  font-size: 12px;
}

.home-content {
  justify-content: column;
  align-items: center;
}

.data-box,
.model-status-box {
  background-color: #2196F3;
  padding: 20px;
  margin: 10px;
  border-radius: 5px;
  color: white;
}

.green-box,
.yellow-box {
  width: 48%;
  height: 20%;
  padding: 5px;
  border: 1px solid #000;
  text-align: left;
  font-weight: bold;
  border-radius: 15px;
}

.model-title {
  font-weight: bold;
  font-size: 1.0em;
  margin-bottom: 5px;
}

.model-detail {
  font-weight: normal;
}

.charts-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 100%;
  margin-top: 20px;
}

.chart-box {
  text-align: center;
  width: 230px;
}

.chart-title {
  margin-top: 10px;
  font-size: 12px;
  font-weight: bold;
}

.rectangles-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
}

.metrics-title {
  margin-top: 30px;
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  color: #000;
}

.org-select {
  margin-bottom: 20px;
}

.metrics-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.org-select {
  margin-bottom: 10px;
  position: relative;
}

.select-wrapper {
  position: relative;
}

.org-select select {
  font-size: 16px;
  padding: 10px 40px 10px 10px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #ccc;
  appearance: none;
}

.icon-select {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}

.metrics-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.metrics-left {
  width: 40%;
  margin-right: 20px;
}

.metrics-chart {
  width: 60%;
  min-height: 400px;
}

.metric-item {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.metric-item .line {
  width: 5px;
  height: 100%;
  margin-right: 10px;
}

.metric-item.rmse .line {
  background-color: blue;
}

.metric-item.mae .line {
  background-color: red;
}

.controls-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.org-select-slow {
  margin-right: 10px;
}

.org-select-slow select {
  padding: 10px;
  font-size: 16px;
  width: 250px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.3s;
}

.org-select-slow select:focus {
  border-color: #007bff;
}

.search-bar input {
  padding: 8px;
  width: 200px;
}

.model-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  text-align: left;
}

.model-item .sha {
  color: gray;
}

.header h3 {
  padding-top: 30px;
  margin-bottom: 20px;
}

.subheader-item.up {
  min-width: 70px;
}

.card {
  width: 200px;
  padding: 20px;
  margin-left: 90px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  overflow: auto;
  text-align: center;
  cursor: pointer;
  font-size: 15px;
}

.cerrar-sesion {
  background-color: #c1eeaa;
  color: black;
  border: none;
  position: fixed;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  right: 10px;
  top: 80px;
  padding: 15px 30px;
  z-index: 10;
}

.cerrar-sesion:hover {
  background-color: #c7ee97;
}

.logos-container-hc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-hc {
  width: 20%;
  height: auto;
  margin: -70px;
}

.container2Divs-bc {
  display: grid;
  grid-template-columns: 2fr 1fr;
  position: relative;
  margin: 0 40px;
  overflow-y: hidden;
  padding: 20px;
}

.left-column {
  display: flex;
  flex-direction: column;
  margin-right: 50px;
  margin-top: 70px;
  gap: 20px;
}

.left-column-modelos {
  display: flex;
  flex-direction: column;
  margin-right: 50px;
  margin-top: 140px;
  gap: 20px;
}

.input-field {
  width: 60%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 20px;
}

.file-input {
  width: 100%;
  margin-bottom: 10px;
}

.right-image {
  max-width: 100%;
  height: auto;
}

.titulo-cabecera {
  margin-left: 400px;
}

.enviar {
  width: 90%;
  padding: 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
}

.file-icon {
  font-size: 24px;
  margin-bottom: 10px;
}

.download-text {
  text-align: center;
  width: 80%;
  margin-bottom: 20px;
}

.file-drop-zone {
  width: 80%;
  padding: 25px;
  border: 2px dashed #ccc;
  text-align: center;
  cursor: pointer;
  margin-bottom: 20px;
}

.nombre,
.nombre-organizacion {
  margin-left: -90px;
  text-align: center;
  width: 80%;
}

.information-sha {
  overflow-y: auto;
  height: 380px;
  white-space: normal;
}

::-webkit-scrollbar {
  width: 12px; 
  height: 12px; 
}

::-webkit-scrollbar-thumb {
  background-color: #888; 
  border-radius: 10px; 
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555; 
}

::-webkit-scrollbar-track {
  background: #f1f1f1; 
  border-radius: 10px; 
}

.menu-dropdown {
  display: none; 
}

@media (max-width: 398px) {
  .parent {
    grid-template-columns: 1fr; 
  }

  .menu-dropdown {
    display: block; 
  }

  .left-column {
    margin-top: -20px;
    margin-left: 80px;
  }
  .menu-dropdown select {
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 130px
  }

  .menu-dropdown option {
    padding: 10px;
  }

  .cerrar-sesion {
    padding: 10px; 
  }

  .cerrar-sesion span {
    display: none; 
  }

  .logos-container-hc {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .logo-hc {
    width: 40%;
    margin: -20px;
  }

  .rectangles-container {
    display: block;
    width: 650%;
    padding: 20px;
    margin-left: -250px;
  }

  .metrics-title {
    margin-top: 20px;
    margin-left: -200px;
  }

  .charts-container {
    grid-template-columns: repeat(1, 1fr);
    margin-left: -220px;
  }

  .information-sha {
    width: 30%;
    text-overflow: ellipsis;
    margin-left: -220px;
    margin-right: 300px;
  }
  .search-bar input {
    padding: 8px;
    width: 110px;
  }

  .metrics-container {
    display: flex; 
    flex-direction: column; 
    width: 165%; 
    margin-top: 20px;
  }

  .metrics-chart  {
    margin-top: -140px;
    margin-left: -200px;
  }
  
  .controls-container {
    margin-left: -220px;
  }

  .select-wrapper {
    margin-left: -220px;
    padding: 8px;
  }

  .input-field, .file-drop-zone, .enviar {
    width: 300%; 
    margin-left: -80px;
  }

  .titulo-cabecera {
    margin-top: 10px ; 
    margin-left: 100px ; 
    font-size: 16px;
  }

  .right-image{
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .parent {
    grid-template-columns: 1fr 2fr; 
  }

  .left-column {
    margin-left: -30px;
    margin-top: 20px;
  }

  .rectangles-container {
    display: block;
    width: 120%;
    padding: 20px;
  }

  .charts-container {
    grid-template-columns: repeat(1, 1fr);
  }

  .logos-container-hc {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .logo-hc {
    width: 40%;
    margin: -60px -40px;
  }

  .cerrar-sesion {
    top: 90px;
    right: 15px;
  }

  .information-sha {
    width: 45%;
    text-overflow: ellipsis;
  }
  .search-bar input {
    padding: 8px;
    width: 110px;
  }

  .metrics-container {
    display: flex; 
    flex-direction: column; 
    width: 165%; 
    margin-top: 20px;
  }

  .metrics-chart  {
    margin-top: -140px;
    margin-left: -20px;
  }

  .nombre-organizacion {
    margin-left: -40px;
    margin-top: -400px;
  }

  .nombre {
    margin-left: -70px;
  }
  
  .input-field {
    margin-left: 20px;
  }

  .file-drop-zone{
    margin-left: 20px;
    width: 50%;
  }

  .enviar {
    width: 80%;
  }

  .titulo-cabecera {
    margin-left: 200px;
  }

  .right-image{
    margin-top: 250px;
    max-width: 200%;
    margin-left: -150px;
  }
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .parent {
    grid-template-columns: 1fr 3fr; 
  }

  .data-box, .model-status-box {
    padding: 20px;
    margin: 10px;
  }

  .card {
    margin-left: 50px;
  }

  .cerrar-sesion {
    top: 80px;
    right: 20px;
  }

  .nombre-organizacion {
    margin-left: -70px;
    margin-top: -600px;
  }
  
  .input-field {
    margin-left: 20px;
  }

  .file-drop-zone{
    margin-left: 20px;
    width: 50%;
  }

  .enviar {
    width: 80%;
  }
  .right-image{
    margin-top: 130px;
    max-width: 150%;
    margin-left: -180px;
  }

  .left-column {
    margin-top: 15px;
  }

  .logos-container-hc {
    margin-top: -5px;
  }
}

@media (min-width: 1769px) {
  .parent {
    grid-template-columns: 1fr 3fr; 
  }

  .data-box, .model-status-box {
    padding: 20px;
    margin: 10px;
  }

  .card {
    margin-left: 50px;
  }

  .cerrar-sesion {
    top: 80px;
    right: 20px;
  }

  .nombre-organizacion {
    margin-left: -70px;
    margin-top: -600px;
  }
  
  .input-field {
    margin-left: 20px;
  }

  .file-drop-zone{
    margin-left: 20px;
    width: 50%;
  }

  .enviar {
    width: 80%;
  }
  .right-image{
    margin-top: 130px;
    max-width: 130%;
    margin-left: -180px;
  }

  .logos-container-hc {
    margin-top: -200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/healthCheck.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;;AAEhC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".parent {\n  display: grid;\n  grid-template-columns: 1fr 4fr;\n  \n}\n\n.div2 {\n  grid-column-start: 1;\n  grid-row-start: 2;\n}\n\n.div3 {\n  grid-column-start: 1;\n  grid-row-start: 3;\n}\n\n.div4 {\n  grid-column-start: 1;\n  grid-row-start: 4;\n}\n\n.div5 {\n  grid-column: span 4;\n  grid-row: span 4;\n  grid-column-start: 2;\n  grid-row-start: 1;\n}\n\n.right-column {\n  grid-column: 2;\n  grid-row: 1;\n  padding: 20px;\n  max-width: 950px;\n}\n\n.subheader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin: 20px 0;\n}\n\n.subheader-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #00000038;\n  padding: 10px 20px;\n  border-radius: 10px;\n  font-size: 16px;\n  min-width: 150px;\n}\n\n.circle-icon {\n  color: green;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.home-content {\n  justify-content: column;\n  align-items: center;\n}\n\n.data-box,\n.model-status-box {\n  background-color: #2196F3;\n  padding: 20px;\n  margin: 10px;\n  border-radius: 5px;\n  color: white;\n}\n\n.green-box,\n.yellow-box {\n  width: 48%;\n  height: 20%;\n  padding: 5px;\n  border: 1px solid #000;\n  text-align: left;\n  font-weight: bold;\n  border-radius: 15px;\n}\n\n.model-title {\n  font-weight: bold;\n  font-size: 1.0em;\n  margin-bottom: 5px;\n}\n\n.model-detail {\n  font-weight: normal;\n}\n\n.charts-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.chart-box {\n  text-align: center;\n  width: 230px;\n}\n\n.chart-title {\n  margin-top: 10px;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.rectangles-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.metrics-title {\n  margin-top: 30px;\n  font-size: 15px;\n  font-weight: bold;\n  text-align: left;\n  color: #000;\n}\n\n.org-select {\n  margin-bottom: 20px;\n}\n\n.metrics-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.org-select {\n  margin-bottom: 10px;\n  position: relative;\n}\n\n.select-wrapper {\n  position: relative;\n}\n\n.org-select select {\n  font-size: 16px;\n  padding: 10px 40px 10px 10px;\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  appearance: none;\n}\n\n.icon-select {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.metrics-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.metrics-left {\n  width: 40%;\n  margin-right: 20px;\n}\n\n.metrics-chart {\n  width: 60%;\n  min-height: 400px;\n}\n\n.metric-item {\n  margin-bottom: 10px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.metric-item .line {\n  width: 5px;\n  height: 100%;\n  margin-right: 10px;\n}\n\n.metric-item.rmse .line {\n  background-color: blue;\n}\n\n.metric-item.mae .line {\n  background-color: red;\n}\n\n.controls-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.org-select-slow {\n  margin-right: 10px;\n}\n\n.org-select-slow select {\n  padding: 10px;\n  font-size: 16px;\n  width: 250px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  outline: none;\n  transition: border-color 0.3s;\n}\n\n.org-select-slow select:focus {\n  border-color: #007bff;\n}\n\n.search-bar input {\n  padding: 8px;\n  width: 200px;\n}\n\n.model-item {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  padding: 10px;\n  border-radius: 5px;\n  box-sizing: border-box;\n  text-align: left;\n}\n\n.model-item .sha {\n  color: gray;\n}\n\n.header h3 {\n  padding-top: 30px;\n  margin-bottom: 20px;\n}\n\n.subheader-item.up {\n  min-width: 70px;\n}\n\n.card {\n  width: 200px;\n  padding: 20px;\n  margin-left: 90px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  overflow: auto;\n  text-align: center;\n  cursor: pointer;\n  font-size: 15px;\n}\n\n.cerrar-sesion {\n  background-color: #c1eeaa;\n  color: black;\n  border: none;\n  position: fixed;\n  font-size: 14px;\n  border-radius: 5px;\n  cursor: pointer;\n  right: 10px;\n  top: 80px;\n  padding: 15px 30px;\n  z-index: 10;\n}\n\n.cerrar-sesion:hover {\n  background-color: #c7ee97;\n}\n\n.logos-container-hc {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo-hc {\n  width: 20%;\n  height: auto;\n  margin: -70px;\n}\n\n.container2Divs-bc {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  position: relative;\n  margin: 0 40px;\n  overflow-y: hidden;\n  padding: 20px;\n}\n\n.left-column {\n  display: flex;\n  flex-direction: column;\n  margin-right: 50px;\n  margin-top: 70px;\n  gap: 20px;\n}\n\n.left-column-modelos {\n  display: flex;\n  flex-direction: column;\n  margin-right: 50px;\n  margin-top: 140px;\n  gap: 20px;\n}\n\n.input-field {\n  width: 60%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.file-input {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.right-image {\n  max-width: 100%;\n  height: auto;\n}\n\n.titulo-cabecera {\n  margin-left: 400px;\n}\n\n.enviar {\n  width: 90%;\n  padding: 10px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n.file-icon {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.download-text {\n  text-align: center;\n  width: 80%;\n  margin-bottom: 20px;\n}\n\n.file-drop-zone {\n  width: 80%;\n  padding: 25px;\n  border: 2px dashed #ccc;\n  text-align: center;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n.nombre,\n.nombre-organizacion {\n  margin-left: -90px;\n  text-align: center;\n  width: 80%;\n}\n\n.information-sha {\n  overflow-y: auto;\n  height: 380px;\n  white-space: normal;\n}\n\n::-webkit-scrollbar {\n  width: 12px; \n  height: 12px; \n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #888; \n  border-radius: 10px; \n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #555; \n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1; \n  border-radius: 10px; \n}\n\n.menu-dropdown {\n  display: none; \n}\n\n@media (max-width: 398px) {\n  .parent {\n    grid-template-columns: 1fr; \n  }\n\n  .menu-dropdown {\n    display: block; \n  }\n\n  .left-column {\n    margin-top: -20px;\n    margin-left: 80px;\n  }\n  .menu-dropdown select {\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-left: 130px\n  }\n\n  .menu-dropdown option {\n    padding: 10px;\n  }\n\n  .cerrar-sesion {\n    padding: 10px; \n  }\n\n  .cerrar-sesion span {\n    display: none; \n  }\n\n  .logos-container-hc {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .logo-hc {\n    width: 40%;\n    margin: -20px;\n  }\n\n  .rectangles-container {\n    display: block;\n    width: 650%;\n    padding: 20px;\n    margin-left: -250px;\n  }\n\n  .metrics-title {\n    margin-top: 20px;\n    margin-left: -200px;\n  }\n\n  .charts-container {\n    grid-template-columns: repeat(1, 1fr);\n    margin-left: -220px;\n  }\n\n  .information-sha {\n    width: 30%;\n    text-overflow: ellipsis;\n    margin-left: -220px;\n    margin-right: 300px;\n  }\n  .search-bar input {\n    padding: 8px;\n    width: 110px;\n  }\n\n  .metrics-container {\n    display: flex; \n    flex-direction: column; \n    width: 165%; \n    margin-top: 20px;\n  }\n\n  .metrics-chart  {\n    margin-top: -140px;\n    margin-left: -200px;\n  }\n  \n  .controls-container {\n    margin-left: -220px;\n  }\n\n  .select-wrapper {\n    margin-left: -220px;\n    padding: 8px;\n  }\n\n  .input-field, .file-drop-zone, .enviar {\n    width: 300%; \n    margin-left: -80px;\n  }\n\n  .titulo-cabecera {\n    margin-top: 10px ; \n    margin-left: 100px ; \n    font-size: 16px;\n  }\n\n  .right-image{\n    display: none;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .parent {\n    grid-template-columns: 1fr 2fr; \n  }\n\n  .left-column {\n    margin-left: -30px;\n    margin-top: 20px;\n  }\n\n  .rectangles-container {\n    display: block;\n    width: 120%;\n    padding: 20px;\n  }\n\n  .charts-container {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .logos-container-hc {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .logo-hc {\n    width: 40%;\n    margin: -60px -40px;\n  }\n\n  .cerrar-sesion {\n    top: 90px;\n    right: 15px;\n  }\n\n  .information-sha {\n    width: 45%;\n    text-overflow: ellipsis;\n  }\n  .search-bar input {\n    padding: 8px;\n    width: 110px;\n  }\n\n  .metrics-container {\n    display: flex; \n    flex-direction: column; \n    width: 165%; \n    margin-top: 20px;\n  }\n\n  .metrics-chart  {\n    margin-top: -140px;\n    margin-left: -20px;\n  }\n\n  .nombre-organizacion {\n    margin-left: -40px;\n    margin-top: -400px;\n  }\n\n  .nombre {\n    margin-left: -70px;\n  }\n  \n  .input-field {\n    margin-left: 20px;\n  }\n\n  .file-drop-zone{\n    margin-left: 20px;\n    width: 50%;\n  }\n\n  .enviar {\n    width: 80%;\n  }\n\n  .titulo-cabecera {\n    margin-left: 200px;\n  }\n\n  .right-image{\n    margin-top: 250px;\n    max-width: 200%;\n    margin-left: -150px;\n  }\n}\n\n@media (min-width: 1200px) and (max-width: 1440px) {\n  .parent {\n    grid-template-columns: 1fr 3fr; \n  }\n\n  .data-box, .model-status-box {\n    padding: 20px;\n    margin: 10px;\n  }\n\n  .card {\n    margin-left: 50px;\n  }\n\n  .cerrar-sesion {\n    top: 80px;\n    right: 20px;\n  }\n\n  .nombre-organizacion {\n    margin-left: -70px;\n    margin-top: -600px;\n  }\n  \n  .input-field {\n    margin-left: 20px;\n  }\n\n  .file-drop-zone{\n    margin-left: 20px;\n    width: 50%;\n  }\n\n  .enviar {\n    width: 80%;\n  }\n  .right-image{\n    margin-top: 130px;\n    max-width: 150%;\n    margin-left: -180px;\n  }\n\n  .left-column {\n    margin-top: 15px;\n  }\n\n  .logos-container-hc {\n    margin-top: -5px;\n  }\n}\n\n@media (min-width: 1769px) {\n  .parent {\n    grid-template-columns: 1fr 3fr; \n  }\n\n  .data-box, .model-status-box {\n    padding: 20px;\n    margin: 10px;\n  }\n\n  .card {\n    margin-left: 50px;\n  }\n\n  .cerrar-sesion {\n    top: 80px;\n    right: 20px;\n  }\n\n  .nombre-organizacion {\n    margin-left: -70px;\n    margin-top: -600px;\n  }\n  \n  .input-field {\n    margin-left: 20px;\n  }\n\n  .file-drop-zone{\n    margin-left: 20px;\n    width: 50%;\n  }\n\n  .enviar {\n    width: 80%;\n  }\n  .right-image{\n    margin-top: 130px;\n    max-width: 130%;\n    margin-left: -180px;\n  }\n\n  .logos-container-hc {\n    margin-top: -200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
